(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tl-customer-care"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const allowedTopics = new Set([
      "shipping",
      "product_availability",
      "returns",
      "accessibility",
      "product_question",
      "other"
    ]);

    document.querySelectorAll("[data-customer-care]").forEach((section) => {
      const form = section.querySelector("[data-customer-care-form]");
      const feedback = section.querySelector("[data-customer-care-feedback]");
      const submit = form?.querySelector("[data-customer-care-submit]");
      const startedAt = form?.elements.namedItem("formTimerStartedAt");
      const topic = form?.elements.namedItem("topic");
      const endpoint = section.dataset.endpoint || "";
      const enabled = section.dataset.enabled === "true" && endpoint !== "";
      const successMessage = section.dataset.successMessage || "";
      const failureMessage = section.dataset.failureMessage || "";
      const submittingMessage = section.dataset.submittingMessage || "";

      if (!form || !feedback || !submit || !startedAt || !topic) return;

      startedAt.value = String(Math.round(performance.now()));

      const requestedTopic = new URLSearchParams(window.location.search).get("topic");
      if (requestedTopic && allowedTopics.has(requestedTopic)) {
        topic.value = requestedTopic;
      }

      form.addEventListener("submit", async (event) => {
        event.preventDefault();
        if (!enabled || !form.reportValidity()) return;

        submit.disabled = true;
        form.setAttribute("aria-busy", "true");
        feedback.textContent = submittingMessage;
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 12000);

        try {
          const response = await fetch(endpoint, {
            method: "POST",
            mode: "cors",
            credentials: "omit",
            signal: controller.signal,
            headers: {
              "Accept": "application/json",
              "Content-Type": "application/json",
              "X-Trinelle-Form": "customer-care-v1"
            },
            body: JSON.stringify({
              name: form.elements.namedItem("name").value,
              email: form.elements.namedItem("email").value,
              topic: topic.value,
              message: form.elements.namedItem("message").value,
              sourcePage: window.location.pathname,
              privacyAcknowledged: form.elements.namedItem("privacyAcknowledged").checked,
              companyWebsite: form.elements.namedItem("companyWebsite").value,
              formCompletionMs: Math.max(
                0,
                Math.round(performance.now() - Number(startedAt.value))
              )
            })
          });
          const result = await response.json().catch(() => null);
          if (!response.ok || !result?.ok) throw new Error("submission failed");

          form.reset();
          startedAt.value = String(Math.round(performance.now()));
          feedback.textContent = result.message || successMessage;
          feedback.focus();
        } catch {
          feedback.textContent = failureMessage;
          feedback.focus();
        } finally {
          window.clearTimeout(timeout);
          submit.disabled = false;
          form.removeAttribute("aria-busy");
        }
      });

      if (enabled) {
        submit.type = "submit";
        submit.disabled = false;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
